import type { DriveStep } from 'driver.js'

export const modelsTour: Array<DriveStep> = [
  {
    element: '#model-catalog',
    popover: {
      title: 'Model Catalog',
      description:
        '100+ models including Claude, GPT, Gemini, DeepSeek, Grok, Qwen, Kimi, and more—all accessible through one unified API.',
      side: 'top',
    },
  },
  {
    element: '#tier-filter',
    popover: {
      title: 'Provider Tiers Explained',
      description:
        '<strong>Economy</strong>: Cheapest providers<br><strong>Standard</strong>: Balanced cost and quality<br><strong>Premium</strong>: Fastest and most reliable<br><br>Choose based on your priority.',
      side: 'bottom',
    },
  },
  {
    element: '#model-card-example',
    popover: {
      title: 'Model Details',
      description:
        'View pricing per 1M tokens, context window size, supported features (vision, function calling), and average latency.',
      side: 'right',
    },
  },
  {
    element: '#fallback-chain-config',
    popover: {
      title: 'Smart Fallback System',
      description:
        'If your primary provider fails or hits rate limits, ModelStack automatically routes to backup models. Configure your failover chain here.',
      side: 'left',
    },
  },
  {
    element: '#model-routing-settings',
    popover: {
      title: 'Advanced Routing',
      description:
        'Set per-model routing preferences: preferred providers, max retries, timeout thresholds, and custom load balancing.',
      side: 'bottom',
    },
  },
  {
    element: '#model-playground',
    popover: {
      title: 'Test Before You Deploy',
      description:
        'Try any model in our interactive playground. Test prompts, compare outputs across models, and validate performance before integrating.',
      side: 'top',
    },
  },
]
